import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { PayerTypeSchema } from '../contracts';

const _GetPayerTypesRequestDtoSchema = z.object({
  facilityId: z.number(),
});

const GetPayerTypesResponseDtoSchema = z.array(
  z.object({
    id: z.number(),
    productTypeName: z.string(),
    isDisabled: z.boolean(),
    payer: PayerTypeSchema.nullable(),
    facilityId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  })
);

export type GetPayerTypesRequestDto = z.infer<
  typeof _GetPayerTypesRequestDtoSchema
>;
export type GetPayerTypesResponseDto = z.infer<
  typeof GetPayerTypesResponseDtoSchema
>;

export const getPayerTypes = (
  params: GetPayerTypesRequestDto,
  config?: AxiosRequestConfig<GetPayerTypesRequestDto>
) => {
  const { facilityId } = params;

  return api
    .get(`/facilities/product-types/${facilityId}`, {
      params,
      ...config,
    })
    .then(responseContract(GetPayerTypesResponseDtoSchema));
};
